//
//
//
//
//
//
import echarts from "echarts";
import { debounce } from '@/utils';
export default {
  props: ["chartData", "lendName", "total"],
  data: function data() {
    return {
      chart: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.initChart();
    this.__resizeHanlder = debounce(function () {
      if (_this.chart) {
        _this.chart.resize();
      }
    }, 100);
    window.addEventListener("resize", this.__resizeHanlder);
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }

    this.chart.dispose();
    this.chart = null;
    window.removeEventListener('resize', this.__resizeHanlder);
  },
  watch: {
    chartData: {
      deep: true,
      handler: function handler(val) {
        this.setOptions(val);
      }
    }
  },
  methods: {
    setOptions: function setOptions() {
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: {
          left: "2%",
          right: "2%",
          bottom: "2%",
          top: "10%",
          containLabel: true
        },
        xAxis: [{
          type: "category",
          data: this.lendName,
          axisTick: {
            alignWithLabel: true
          }
        }],
        yAxis: [{
          type: "value",
          splitNumber: 1,
          min: 0
        }],
        series: [{
          label: {
            show: true,
            position: "outside"
          },
          itemStyle: {
            color: "#0b98ff"
          },
          // backgroundStyle:{
          //     color: "rgba(180, 180, 180, 0.2)"
          // },
          // name: "合同数",
          type: "bar",
          barWidth: "20%",
          data: this.chartData
        }]
      });
    },
    initChart: function initChart() {
      console.log(this.chartData);
      this.chart = echarts.init(this.$refs.statusEchart, "macarons");
      this.setOptions(this.chartData);
    }
  }
};